import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../css/opt-out.css';

export default function OptOut() {
    const [parentName, setParentName] = useState('');
    const [parentEmail, setParentEmail] = useState('');
    const [studentName, setStudentName] = useState('');
    const [reason, setReason] = useState('');

    const [submitting, setSubmitting] = useState(false);
    const [result, setResult] = useState(null); // { ok: true } | { ok: false }

    async function handleSubmit(e) {
        e.preventDefault();
        setSubmitting(true);
        setResult(null);

        const message = `PERFORMANCE OPT-OUT REQUEST\n\nStudent: ${studentName}\nParent/Guardian: ${parentName}\n\nReason (optional): ${reason || '(none given)'}`;

        try {
            const res = await fetch('/send', {
                method: 'POST',
                headers: { 'Content-type': 'application/json' },
                body: JSON.stringify({
                    mailerState: {
                        name: parentName,
                        email: parentEmail,
                        message,
                    },
                }),
            });
            const data = await res.json();

            if (data.status === 'success') {
                setResult({ ok: true });
                setParentName('');
                setParentEmail('');
                setStudentName('');
                setReason('');
            } else {
                setResult({ ok: false });
            }
        } catch (err) {
            setResult({ ok: false });
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="optOut-content">
            <Helmet>
                <title>In Motion Dance | Performance Opt-Out</title>
            </Helmet>
            <h1>Performance Opt-Out</h1>
            <p className="optOut-subtitle">
                Most dancers do perform, but if your dancer will not be participating in an
                upcoming performance, please let us know using this form.
            </p>

            <form className="optOut-form" onSubmit={handleSubmit}>
                <label>
                    Student Name
                    <input
                        type="text"
                        value={studentName}
                        onChange={(e) => setStudentName(e.target.value)}
                        required
                    />
                </label>

                <label>
                    Parent/Guardian Name
                    <input
                        type="text"
                        value={parentName}
                        onChange={(e) => setParentName(e.target.value)}
                        required
                    />
                </label>

                <label>
                    Your Email
                    <input
                        type="email"
                        value={parentEmail}
                        onChange={(e) => setParentEmail(e.target.value)}
                        required
                    />
                </label>

                <label>
                    Reason (optional)
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Optional — anything you'd like us to know"
                    />
                </label>

                <button type="submit" disabled={submitting}>
                    {submitting ? 'Sending…' : 'Submit Opt-Out'}
                </button>

                {result && result.ok && (
                    <p className="optOut-success">✅ Received! Thank you for letting us know.</p>
                )}
                {result && !result.ok && (
                    <p className="optOut-error">Something went wrong sending this. Please try again, or call us directly.</p>
                )}
            </form>

            <p className="optOut-backLink"><Link to="/performances">← Back to Performances &amp; Recitals</Link></p>
        </div>
    )
}
